import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  AEROMEGH_SERVICES,
  DISCOUNT_TYPES,
  PRICE_BY_TYPES,
  SERVICE_TYPES,
  STATUS,
} from "../../appConstants";
import Toggle from "react-toggle";
import {
  acresToSquareKilometers,
  squareKilometersToAcres,
} from "../../ReusableFunctions/reusableFunctions";
import PaymentSummary from "./PaymentSummary";
import useWindowSize from "../../hooks/useWindowSize";
import { useSelector } from "react-redux";

const RequestDiscount = forwardRef(
  (
    { request, oldRequest, changeValue, hideToggle, style, updateRequest },
    ref,
  ) => {
    const [toggle, setToggle] = useState(true);
    const [invoice, setInvoice] = useState(request?.invoice || {});
    const [dspDiscount, setDspDiscount] = useState({});
    const [discount, setDiscount] = useState(0);
    const [isDiscountEditable, setisDiscountEditable] = useState(false);
    const { currentWidth } = useWindowSize();
    const user = useSelector((state) => state.user.user);
    const [paymentSummaryCalculations, setPaymentSummaryCalculations] =
      useState({
        price_by: PRICE_BY_TYPES.TANK,
        pesticide_per_acre_subsidy: 0,
        service_amount_per_acre: 0,
        field_area: 0,
      });
    useImperativeHandle(ref, () => ({
      getInvoice: () => invoice,
    }));
    const applyDiscount = (discountValue) => {
      const newInvoice = {
        ...invoice,
        ...getInvoiceInDetail({
          ...request,
          invoice: {
            ...request.invoice,
            applied_discounts: [
              {
                discount: discountValue,
              },
            ],
          },
        }),
      };
      setInvoice(newInvoice);
      // callback(newInvoice)
      setDspDiscount({ ...dspDiscount, discount: discountValue });
    };

    const calculatePercentageTotal = (value, percentage) =>
      (value * percentage) / 100;
    const getAppliedTotalAmountOfCoupon = (service_amount, coupon) => {
      if (coupon) {
        if (coupon.is_discount_in_percentage) {
          const totalAppliedAmountOfCouponViaPercentage =
            calculatePercentageTotal(
              service_amount,
              coupon.discount_percentage,
            );
          return Number(
            totalAppliedAmountOfCouponViaPercentage <
              Number(coupon.max_discount_value)
              ? totalAppliedAmountOfCouponViaPercentage
              : coupon.max_discount_value,
          );
        } else {
          return Number(coupon.discount_cost);
        }
      } else return 0;
    };

    useEffect(() => {
      if (dspDiscount?.discount) {
        setDiscount(dspDiscount.discount);
        setToggle(
          dspDiscount?.discount != undefined && dspDiscount?.discount != 0
            ? true
            : false,
        );
      }
      if (toggle) {
        document
          .getElementById("discount-input")
          ?.addEventListener("wheel", function (event) {
            event.preventDefault();
          });
      }
    }, [dspDiscount?.discount, toggle]);

    useEffect(() => {
      const dspDiscount = (discount
        ? { discount, discount_type: "dsp_request_discount" }
        : request?.invoice?.applied_discounts?.find(
            (ad) => ad.discount_type === DISCOUNT_TYPES.DSP_REQUEST_DISCOUNT,
          )) || { discount: 0, discount_type: "dsp_request_discount" };
      let dsp_discount = request?.invoice?.applied_discounts?.find(
        (d) => d.discount_type === "dsp_request_discount",
      );
      setDiscount(() =>
        dsp_discount?.discount !== undefined ? dsp_discount?.discount : 0,
      );
      setDspDiscount(dspDiscount);
      setInvoice({
        ...invoice,
        ...getInvoiceInDetail({
          ...request,
          invoice: {
            ...request.invoice,
            applied_coupons:
              oldRequest.status !== STATUS.PAID &&
              request.status === STATUS.PAID
                ? request.invoice?.applied_coupons?.filter(
                    (c) => c.coupon_type !== "SYSTEM",
                  )
                : request.invoice?.applied_coupons,
            applied_discounts: [dspDiscount],
          },
        }),
      });
    }, [request.invoice, request.service_completed_area, request.status]);

    const calculateTotalDiscount = (applied_discounts) => {
      return applied_discounts.reduce((total, discountObj) => {
        return total + discountObj.discount;
      }, 0);
    };

    const getInvoiceInDetail = ({
      field_area,
      service_completed_area,
      price_by,
      invoice: {
        pesticide_per_acre_subsidy,
        service_amount,
        total_amount,
        applied_tax_amount,
        tax,
        cgst,
        sgst,
        pesticides_subsidy,
        service_amount_with_subsidy,
        applied_coupons,
        applied_discounts,
        invoice_currency,
      },
    }) => {
      console.log("invoice", invoice);
      service_completed_area = Number(service_completed_area);
      field_area = Number(oldRequest?.service_completed_area) || field_area;
      const service_amount_per_acre = service_amount / field_area;
      service_amount =
        service_amount_per_acre * (service_completed_area || field_area);
      // pesticides_subsidy =
      //   price_by === PRICE_BY_TYPES.TANK
      //     ? Number(pesticide_per_acre_subsidy) *
      //       Number(service_completed_area || field_area)
      //     : Number(pesticide_per_acre_subsidy) *
      //       squareKilometersToAcres(
      //         Number(service_completed_area || field_area),
      //       );
      pesticides_subsidy = price_by === PRICE_BY_TYPES.TANK
    ? Number(pesticide_per_acre_subsidy) * Number(service_completed_area || field_area)
    : Number(pesticide_per_acre_subsidy) * squareKilometersToAcres(Number(service_completed_area || field_area))
      service_amount_with_subsidy = Number(service_amount) - pesticides_subsidy;
      applied_coupons = applied_coupons?.filter(
        (c) => service_amount_with_subsidy >= Number(c.min_order_value),
      );
      ///
      const bhumeetCoupons = applied_coupons?.filter(
        (ac) => ac.coupon_type === "SYSTEM",
      );
      const dspCoupons = applied_coupons?.filter(
        (ac) => ac.coupon_type === "DSP",
      );
      let applied_bhumeet_coupon_total_amount = 0,
        applied_dsp_coupon_total_amount = 0;
      if (bhumeetCoupons?.length > 0) {
        applied_bhumeet_coupon_total_amount = getAppliedTotalAmountOfCoupon(
          service_amount_with_subsidy,
          bhumeetCoupons[0],
        );
      }
      if (dspCoupons?.length > 0) {
        applied_dsp_coupon_total_amount = getAppliedTotalAmountOfCoupon(
          service_amount_with_subsidy,
          dspCoupons[0],
        );
      }
      const total_discounted_amount_via_coupons =
        applied_bhumeet_coupon_total_amount + applied_dsp_coupon_total_amount;
      const total_dsp_discount_percentage =
        calculateTotalDiscount(applied_discounts);
      const total_discounted_amount_via_dsp = calculatePercentageTotal(
        service_amount_with_subsidy,
        total_dsp_discount_percentage,
      );
      //
      const service_amount_with_applied_discount_and_coupons =
        service_amount_with_subsidy -
        total_discounted_amount_via_coupons -
        total_discounted_amount_via_dsp;
      // const applied_csgt_amount = calculatePercentageTotal(
      //   service_amount_with_applied_discount_and_coupons,
      //   cgst,
      // );
      // const applied_sgst_amount = calculatePercentageTotal(
      //   service_amount_with_applied_discount_and_coupons,
      //   sgst,
      // );
      // const isTaxApplicable =
      //   user.dsp?.is_tax_applicable !== false &&
      //   Number(user?.dsp?.tax || 0) > 0;

      // const applied_csgt_amount = calculatePercentageTotal(
      //   service_amount_with_applied_discount_and_coupons,
      //   cgst,
      // );

      // const applied_sgst_amount = calculatePercentageTotal(
      //   service_amount_with_applied_discount_and_coupons,
      //   sgst,
      // );
      const applied_csgt_amount = 0;
      const applied_sgst_amount = 0;
      // const total_tax_amount = (request.dsp?.country_code === '91' || request.dsp?.country_code === '+91') ? calculatePercentageTotal(service_amount_with_applied_discount_and_coupons, tax) : 0;

      // const effectiveTax = isTaxApplicable ? tax : 0;

      // const total_tax_amount = isTaxApplicable
      //   ? calculatePercentageTotal(
      //       service_amount_with_applied_discount_and_coupons,
      //       Number(user?.dsp?.tax || 0),
      //     )
      //   : 0;
      // const applied_tax_amount=calculatePercentageTotal()

      const savedTax = Number(request?.invoice?.tax || 0);
      const isTaxApplicable = savedTax > 0;

      const total_tax_amount = isTaxApplicable
        ? calculatePercentageTotal(
            service_amount_with_applied_discount_and_coupons,
            savedTax,
          )
        : 0;

      let total_amount_with_applied_coupons_and_gst_and_discounts =
        service_amount_with_applied_discount_and_coupons;

      // if (isTaxApplicable) {
      //   total_amount_with_applied_coupons_and_gst_and_discounts =
      //     total_amount_with_applied_coupons_and_gst_and_discounts +
      //     applied_csgt_amount +
      //     applied_sgst_amount;
      // } else {
      //   total_amount_with_applied_coupons_and_gst_and_discounts +=
      //     total_tax_amount;
      // }
      total_amount_with_applied_coupons_and_gst_and_discounts +=
        total_tax_amount;
        const isAcreType = price_by == PRICE_BY_TYPES.ACRE || price_by == "hectare" || !price_by;
      // setPaymentSummaryCalculations({
        
      //   service_amount_per_acre:
      //     price_by == PRICE_BY_TYPES.ACRE || !price_by
      //       ? acresToSquareKilometers(service_amount_per_acre)
      //       : service_amount_per_acre,
      //   field_area:
      //     price_by == PRICE_BY_TYPES.ACRE || !price_by
      //       ? squareKilometersToAcres(service_completed_area ?? field_area)
      //       : (service_completed_area ?? field_area),
      //   price_by,
      //   pesticide_per_acre_subsidy:
      //     price_by == PRICE_BY_TYPES.ACRE || !price_by
      //       ? acresToSquareKilometers(pesticide_per_acre_subsidy)
      //       : pesticide_per_acre_subsidy,
      // });

      setPaymentSummaryCalculations({
    service_amount_per_acre: isAcreType 
        ? acresToSquareKilometers(service_amount_per_acre) 
        : service_amount_per_acre,
    field_area: isAcreType 
        ? squareKilometersToAcres(service_completed_area ?? field_area) 
        : (service_completed_area ?? field_area),
    price_by,
    pesticide_per_acre_subsidy: isAcreType 
        ? acresToSquareKilometers(pesticide_per_acre_subsidy) 
        : pesticide_per_acre_subsidy,
});
      return {
        service_amount,
        total_dsp_discount_percentage,
        applied_csgt_amount,
        pesticides_subsidy,
        applied_sgst_amount,
        service_amount_with_applied_discount_and_coupons,
        total_discounted_amount_via_dsp,
        total_amount_with_applied_coupons_and_gst_and_discounts,
        discount_amount: total_discounted_amount_via_dsp,
        total_amount: Number(
          total_amount_with_applied_coupons_and_gst_and_discounts.toFixed(2),
        ),
        applied_dsp_coupon_total_amount,
        applied_bhumeet_coupon_total_amount,
        total_discounted_amount_via_coupons,
        applied_coupons,
        total_tax_amount,
        // tax,
        tax: savedTax,
        cgst,
        sgst,
        invoice_currency: user?.dsp?.invoice_currency || null,
        // invoice_currency: request?.invoice?.invoice_currency || null,
        // country_code: request?.dsp?.country_code || user?.dsp?.country_code,
      };
    };

    return (
      <>
        <div
          style={{ height: "100%", width: "100%", display: "flex", ...style }}
        >
          <div className={`${currentWidth < 1600 ? "w-[75%]" : "w-[60%]"}`}>
            <PaymentSummary request={request} invoice={invoice} />
          </div>
          {!hideToggle && (
            <div
              style={{
                display: "flex",
                width: "50%",
                gap: "10px",
                justifyContent: "flex-end",
                marginBottom: "15px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <div className="flex flex-col ml-auto my-2 p-1">
                  <div className="flex gap-2">
                    <div
                      className="font-manrope"
                      style={{
                        minWidth: "110px",
                        fontSize: "13px",
                        color: "#3B3B3B",
                      }}
                    >
                      Add Discount (%){" "}
                    </div>
                    <Toggle
                      height={"px"}
                      icons={false}
                      checked={toggle}
                      onChange={(e) => {
                        if (
                          !(
                            request.status == STATUS.PAID ||
                            request.status == STATUS.CANCELLED
                          ) &&
                          isDiscountEditable
                        ) {
                          setDiscount(0);
                          applyDiscount(0);
                          changeValue(0);
                          setToggle(e.target.checked);
                        }
                      }}
                    />
                    {request?.user != null &&
                      !isDiscountEditable &&
                      ![STATUS.PAID, STATUS.PLACED, STATUS.CANCELLED].includes(
                        request?.status,
                      ) && (
                        <span
                          className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline "
                          onClick={() => setisDiscountEditable(true)}
                        >
                          Change
                        </span>
                      )}
                    {isDiscountEditable &&
                      ![STATUS.PAID].includes(request?.status) && (
                        <span
                          className="text-[#0F5EFF] font-manrope text-[15px] cursor-pointer font-[600] underline "
                          onClick={async () => {
                            await updateRequest();
                            setisDiscountEditable(false);
                          }}
                        >
                          update
                        </span>
                      )}
                  </div>
                  <div
                    style={{ width: "70%", height: "30px", marginTop: "5px" }}
                  >
                    {toggle && (
                      <input
                        id="discount-input"
                        type="number"
                        step="0.01"
                        className={`${
                          !isDiscountEditable && "cursor-not-allowed"
                        }`}
                        disabled={!isDiscountEditable}
                        max={99.99}
                        min={0}
                        onChange={(e) => {
                          if (
                            e.target.value <= 99.99 &&
                            e.target.value >= 0 &&
                            e.target.value.length <= 5
                          ) {
                            setDiscount(e.target.value);
                            applyDiscount(e.target.value);
                            changeValue(e.target.value);
                          }
                        }}
                        value={discount}
                        style={{
                          padding: "0 10px",
                          background: "#F3F3F3",
                          border: "1px solid #D9D9D9",
                          outline: "none",
                          borderRadius: "4px",
                          width: "100%",
                          fontSize: "13px",
                          color: "#1E1E1E",
                          height: "100%",
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  },
);

export default RequestDiscount;
